import { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import SliderIndicator from '../SliderIndicator'
import { SwiperResultProps } from './SwiperResult.types'
import type { Swiper as SwiperType } from 'swiper'
import styles from './SwiperResult.module.css'

const SwiperResult: React.FC<SwiperResultProps> = ({
  components,
  autoplayDelay = 3000,
  onCardClick,
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const swiperRef = useRef<SwiperType | null>(null)

  const handleIndicatorClick = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index)
    }
  }

  // Fix warning when components items is empty then we don't need to render swiper
  if (!components || components.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        speed={800}
        pagination={{
          clickable: true,
          renderBullet: function (className) {
            return `<span class="${className}"></span>`
          },
        }}
        autoplay={{
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex)
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        className={styles.swiperWrapper}
      >
        {components.map((component, index) => (
          <SwiperSlide
            key={index}
            onClick={() => onCardClick?.(index)}
            className={styles.slide}
          >
            {component}
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={styles.indicatorWrapper}>
        <SliderIndicator
          total={components.length}
          activeIndex={activeIndex + 1}
          onIndicatorClick={handleIndicatorClick}
        />
      </div>
    </div>
  )
}

export default SwiperResult
